const audiotriggers = {
    "Music:Title": {
        "volume": 0.37,
        "label": "music",
        "type": "sequence:loop",
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Main_Menu_MX.ogg").default),
        "kill": {"label": "music"},
    },
    "Music:Chill": {
        "volume": 0.37,
        "label": "music",
        "type": "sequence:loop",
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Intro.ogg").default),
        "kill": {"label": "music"},
    },
    "Music:Combat:A": {
        "volume": 0.37,
        "label": "music",
        "type": "simultaneously",
        "hasIntensity": true,
        "loop": true,
        "audio": [
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop1_L1.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop1_L2.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop1_L3.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop1_L4.ogg").default),
        ],
        "kill": {"label": "music"},
    },
    "Music:Combat:B": {
        "volume": 0.37,
        "label": "music",
        "type": "simultaneously",
        "hasIntensity": true,
        "loop": true,
        "audio": [
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop2_L1.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop2_L2.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop2_L3.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop2_L4.ogg").default),
        ],
        "kill": {"label": "music"},
    },
    "Music:Combat:C": {
        "volume": 0.37,
        "label": "music",
        "type": "simultaneously",
        "hasIntensity": true,
        "loop": true,
        "audio": [
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop3_L1.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop3_L2.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop3_L3.ogg").default),
        ],
        "kill": {"label": "music"},
    },
    "Music:Combat:D": {
        "volume": 0.37,
        "label": "music",
        "type": "sequence:loop",
        "loop": true,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop3_Transition.ogg").default),
        "kill": {"label": "music"},
    },
    "Music:Combat:E": {
        "volume": 0.37,
        "label": "music",
        "type": "simultaneously",
        "hasIntensity": true,
        "loop": true,
        "audio": [
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop4_L1.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop4_L2.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Loop4_L3.ogg").default),
        ],
        "kill": {"label": "music"},
    },
    "Music:Combat:Done": {
        "volume": 0.37,
        "label": "music",
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/LD50_MX_Outro.ogg").default),
        "kill": {"label": "music"},
    },
    "Music:Town": {
        "volume": 0.37,
        "label": "music",
        "type": "sequence:loop",
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Sewer_Town_Master.ogg").default),
        "kill": {"label": "music"},
    },
    "Ambience:General": {
        "volume": 0.37,
        "label": "ambience",
        "type": "sequence:loop",
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Wasteland_Ambience_Final.ogg").default),
        "kill": {"label": "ambience"},
    },
    "Ambience:Town": {
        "volume": 0.37,
        "label": "ambience",
        "type": "sequence:loop",
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/Town_Ambience.ogg").default),
        "kill": {"label": "ambience"},
    },


    "Unit:Attacked": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Defend.ogg").default),
    },
    "Unit:Attack:Melee": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Attack_Melee.ogg").default),
    },
    "Unit:Attack:Ranged": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Attack_Ranged.ogg").default),
    },
    "Unit:Garden": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Farmer_Garden.ogg").default),
    },
    "Unit:Harvest": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Unit_Crop_Harvest.ogg").default),
    },
    "Selection:Start": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Start.ogg").default),
    },
    "Selection:Move": {
        "volume": 0.33,
        "type": "once:randomly",
        "audio": [
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Hover_1.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Hover_2.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Hover_3.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Hover_4.ogg").default),
            new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Hover_5.ogg").default),
        ]
    },
    "Selection:Cancel": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Cancel.ogg").default),
    },
    "Selection:Finish": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Selection_Finish.ogg").default),
    },
    "UndoAction": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Player_Undo.ogg").default),
    },
    "EndTurn": {
        "volume": 0.5,
        "audio": new Audio(require("@frog/source/assets/audio/apocalypse-tactics/fmod/Assets/Player_EndTurn.ogg").default),
    },

    "Unit:Death": {
        "volume": 0.33,
        "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Death.ogg").default),
    },



    // // LEVIATHAN TACTICS
    // "Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Player_Start.mp3").default),
    // },
    // "Music:Opening": {
    //     "volume": 0.33,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/music/title.mp3").default),
    //     "kill": {"label": "music"},
    // },
    // "Music:Battle": {
    //     "volume": 0.33,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/music/battle.mp3").default),
    //     "kill": {"label": "music"},
    // },
    // "Music:Success": {
    //     "volume": 0.33,
    //     "label": "music",
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/music/success.mp3").default),
    //     "kill": {"label": "music"},
    // },
    // "Music:Failure": {
    //     "volume": 0.33,
    //     "label": "music",
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/music/failure.mp3").default),
    //     "kill": {"label": "music"},
    // },
    // "Ambience:General": {
    //     "volume": 0.5,
    //     "type": "sequence:loop",
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Ambience_General.mp3").default),
    // },
    // "Unit:Move:Infantry": {
    //     "volume": 0.25,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Move_01.mp3").default),
    //         new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Move_02.mp3").default),
    //         new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Move_03.mp3").default),
    //         new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Move_04.mp3").default),
    //     ]
    // },
    // "Unit:Death": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Death_Enemy.mp3").default),
    // },
    // "Unit:Death:Player": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Death_Player.mp3").default),
    // },
    // "Selection:Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Selection_Start.mp3").default),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Selection_Move.mp3").default),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Selection_Cancel.mp3").default),
    // },
    // "Selection:Finish": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Selection_Finish.mp3").default),
    // },
    // "EndTurn": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_end_Turn.mp3").default),
    // },
    // "UndoAction": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Player_Undo.mp3").default),
    // },
    // "Unit:Dragoon:Jump": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Dragoon_Jump.mp3").default),
    // },
    // "Unit:Dragoon:Land": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Dragoon_Land.mp3").default),
    // },
    // "Unit:Dragoon:Stab": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Dragoon_Stab.mp3").default),
    // },
    // "Unit:Samurai:Attack": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Fiego_Attack.mp3").default),
    // },
    // "Unit:Samurai:Sheath": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Fiego_Sheath.mp3").default),
    // },
    // "Unit:Samurai:Reel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Fiego_Reel_Attack.mp3").default),
    // },
    // "Unit:Smallfry:Attack": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/leviathan-tactics/sounds/LD_Unit_Enemy_Hit.mp3").default),
    // },
    // // FIRE EMBLEM GBA
    // "Music:Combat:Normal": {
    //     "volume": 0.37,
    //     // "startbuffer": true,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     // "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Companions.ogg").default),
    //     "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/combat1.wav").default),
    //     "kill": {"label": "music"},
    // },
    // "Music:Combat:Epic": {
    //     "volume": 0.37,
    //     // "startbuffer": true,
    //     "label": "music",
    //     "type": "sequence:loop",
    //     // "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Companions.ogg").default),
    //     "audio": new Audio(require("@frog/source/assets/audio/pirate-tactics/combat2.wav").default),
    //     "kill": {"label": "music"},
    // },
    // // FIRE EMBLEM GBA
    // "Unit:Move:Armored": {
    //     "volume": 0.33,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Armor1.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Armor2.ogg").default),
    //     ]
    // },
    // "Unit:Move:Horse": {
    //     "volume": 0.33,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Mounted1.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Mounted2.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Mounted3.ogg").default),
    //     ]
    // },
    // "Unit:Move:Infantry": {
    //     "volume": 0.33,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Infantry1.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Infantry2.ogg").default),
    //     ]
    // },
    // "Unit:Move:Pegasus": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_Flier.ogg").default),
    // },
    // "Unit:Move:Wyvern": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Map_Step_FDragon.ogg").default),
    // },
    // "Unit:Attack": {
    //     "volume": 0.33,
    //     "type": "once:randomly",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing1.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing2.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing3.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing4.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing5.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Swing6.ogg").default),
    //     ]
    // },
    // "Unit:Attack:Hit": {
    //     "volume": 0.33,
    //     "type": "once:randomly",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Hit1.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Hit2.ogg").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Hit3.ogg").default),
    //     ]
    // },
    // "Unit:Attack:Miss": {
    //     "volume": 0.33,
    //     "type": "once:randomly",
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Miss.ogg").default),
    // },
    // "Unit:Heal": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Heal.ogg").default),
    // },
    // "Unit:Attack:FinalHit": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Hit_Kill.ogg").default),
    // },
    // "Unit:Attack:NoDamage": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Hit_NoDamage.ogg").default),
    // },
    // "Unit:Attack:Utility": {
    //     "volume": 0.33,
    //     "type": "once:randomly",
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Sword_Draw.ogg").default),
    // },
    // "Unit:Death": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Death.ogg").default),
    // },
    // "Selection:Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Open.ogg").default),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Cursor_Move.ogg").default),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Cancel.ogg").default),
    // },
    // "Selection:Finish": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Unit_Select.ogg").default),
    // },
    // "UndoAction": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/from-fexna/Confirm.ogg").default),
    // },
    // "EndTurn": {
    //     "volume": 0.5,
    // },

    // If you're looking for good sounds, start here.
    // // FIRE EMBLEM HEROES
    // "Selection:Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/map_4.wav").default),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/map_5.wav").default),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/embedded_6.wav").default),
    // },
    // "Selection:Finish": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/map_3.wav").default),
    // },
    // "EndTurn": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/embedded_5.wav").default),
    // },
    // "UndoAction": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/embedded_4.wav").default),
    // },
    // "Unit:Attack:Hit": {
    //     "volume": 0.5,
    //     "type": "once:randomly",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/btl_blow1.wav").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/btl_blow2.wav").default),
    //     ]
    // },
    // "Unit:Attack:Miss": {
    //     "volume": 0.5,
    //     "type": "once:randomly",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/Attack Miss 1.wav").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/Attack Miss 2.wav").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/Attack Miss 3.wav").default),
    //     ]
    // },
    // "Unit:Heal": {
    //     "volume": 0.5,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/btl_cure1.wav").default),
    // },
    // "Unit:Death": {
    //     "volume": 0.5,
    //     "audio": new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/btl_dead1.wav").default),
    // },
    // "Unit:Move": {
    //     "volume": 0.5,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/fs_normal_sand_1.wav").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/fs_normal_sand_2.wav").default),
    //         new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-heroes/fs_normal_sand_3.wav").default),
    //     ]
    // },


    // BOMBER SFXR
    // "Unit:Move": {
    //     "volume": 0.5,
    //     "type": "once:randomly",
    //     "audio": [
    //         // new Audio(require("@frog/source/assets/audio/dragon-tactics/fe-gba/Attack Hit 4.wav").default),
    //     ]
    // },
    // "Unit:Shotgun:Load": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/archive/chkchk.wav").default)
    // },
    // "Unit:PushGun:Shoot": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/PUSH GUN.wav").default),
    // },
    // "Unit:PullGun:Shoot": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/PULL GUN.wav").default),
    // },
    // "Unit:Shotgun:Shoot": {
    //     "volume": 1,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/BURST GUN 1.wav").default),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/BURST GUN 2.wav").default),
    //     ]
    // },
    // "Unit:Throw": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/BOMB THROW.wav").default),
    // },
    // "Unit:Move": {
    //     "volume": 1,
    //     "type": "once:randomly",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 1.wav").default),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 2.wav").default),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/MOVEMENT BOUNCE 3.wav").default),
    //     ]
    // },
    // "Bomb:Explode": {
    //     "volume": 1,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 1.wav").default),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 2.wav").default),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 3.wav").default),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/EXPLOSION 4.wav").default),
    //     ]
    // },
    // "Music:1": {
    //     "type": "march",
    //     "volume": 0.37,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN1.wav").default),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN1 LOOP.wav").default),
    //     ]
    // },
    // "Music:2": {
    //     "type": "march",
    //     "volume": 0.7,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN2.wav").default),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN2 LOOP.wav").default),
    //     ],
    //     // "killTrigger": "Music:1",
    // },
    // "Music:3": {
    //     "type": "march",
    //     "volume": 0.7,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN3.wav").default),
    //         new Audio(require("@frog/source/assets/audio/bomber-tactics/GJ5 MAIN3 LOOP.wav").default),
    //     ],
    //     // "killTrigger": "Music:1",
    // },
    // "Selection:Start": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Select.wav").default),
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/SELECT UNIT.wav").default),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UnSelect.wav").default),
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CANCEL.wav").default),
    // },
    // "Selection:Finish": {
    //     "volume": 0.85,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/PerformAction.wav").default),
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CONFIRM.wav").default),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Hover.wav").default),
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/CURSOR MOVEMENT.wav").default),
    // },
    // "EndTurn": {
    //     "volume": 0.85,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CONFIRM (Generic).wav").default)
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/END TURN.wav").default),
    // },
    // "UndoAction": {
    //     "volume": 0.85,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX TEXT WINDOW CLOSE 2.wav").default)
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UndoAction.wav").default)
    //     "audio": new Audio(require("@frog/source/assets/audio/bomber-tactics/UNDO.wav").default),
    // },


    // "Unit:Death": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CANNOT CONFIRM.wav").default)
    // },
    // "Unit:Death:Falling": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Falling Off Map.wav").default)
    // },
    // "Unit:Escape": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Escape Map Zipline.wav").default)
    // },
    // "Flipper:Swing": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Bo Staff Flip.wav").default)
    //     ]
    // },
    // "Pusher:Swing": {
    //     "volume": 1,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 1.wav").default),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 2.wav").default),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Push 3.wav").default),
    //     ]
    // },
    // "Robot:Swing": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Robot Sounds.wav").default)
    //     ]
    // },
    // "Puller:Throw": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Frisbee Throw.wav").default)
    // },
    // "Puller:Pull": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Frisbee Pull In.wav").default)
    // },
    // "Aoe-er:Shoot": {
    //     "volume": 1,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Fire.wav").default)
    // },
    // "Aoe-er:Explosion": {
    //     "volume": 1,
    //     "type": "once:rotation",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Explosion.wav").default),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Cannon Explosion.wav").default),
    //     ]
    // },
    // "Victory": {
    //     "volume": 1,
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Victory Theme 1.wav").default)
    //     ],
    // },
    // "Victory:Final": {
    //     "volume": 1,
    //     "type": "march",
    //     "audio": [
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Victory Theme ENDGAME.wav").default),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Main Theme Full.wav").default),
    //         new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 Main Theme Loop.wav").default),
    //     ],
    //     "killTrigger": "Music:Final",
    // }
    // "Selection:Start": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Select.wav").default),
    // },
    // "Selection:Cancel": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UnSelect.wav").default),
    // },
    // "Selection:Finish": {
    //     "volume": 0.85,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/PerformAction.wav").default),
    // },
    // "Selection:Move": {
    //     "volume": 0.33,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/Hover.wav").default),
    // },
    // "EndTurn": {
    //     "volume": 0.85,
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX CONFIRM (Generic).wav").default)
    // },
    // "UndoAction": {
    //     "volume": 0.85,
    //     // "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/LD47 SFX TEXT WINDOW CLOSE 2.wav").default)
    //     "audio": new Audio(require("@frog/source/assets/audio/skyline-tactics/UndoAction.wav").default)
    // },
}

import * as Objdict from "objdict"
Objdict.forEach(audiotriggers, (audiotrigger, key) => {
    audiotrigger.key = key
})

export default audiotriggers
